/**
 * Display helpers for order-ahead / KDS queue sales (customer from API).
 */

export function getQueueCustomerName (sale) {
  const c = sale?.customer
  if (!c) return null
  if (c.display_name) return c.display_name
  if (c.full_name) return c.full_name
  const fn = c.first_name || ''
  const ln = c.last_name || ''
  const t = `${fn} ${ln}`.trim()
  return t || null
}

/**
 * Prefer primary phone when present; otherwise first phone.
 * @param {object} sale
 * @returns {string|null}
 */
export function getQueueCustomerPhone (sale) {
  const phones = sale?.customer?.phones
  if (!Array.isArray(phones) || !phones.length) return null
  const primary = phones.find((p) => p.is_primary)
  const row = primary || phones[0]
  return row?.phone ? String(row.phone) : null
}
